import ProgresBarContent from './Content';
import ProgressBarProvider from './context';

export interface ProgressBarItemSingle {
  type: 'single';
  title: string;
  active: boolean;
}

export interface ProgressBarItemMulti {
  type: 'multi';
  title: string;
  substeps: ProgressBarItemSingle[];
}

export type ProgressBarItem = ProgressBarItemSingle | ProgressBarItemMulti;

export interface ProgressBarProps {
  items: ProgressBarItem[];
  lastPassed?: boolean;
  isLoading?: boolean;
}

const ProgressBar: React.FunctionComponent<ProgressBarProps> = function ({
  items,
  lastPassed,
  isLoading,
}) {
  return (
    <ProgressBarProvider
      items={items}
      lastPassed={lastPassed}
      isLoading={isLoading}
    >
      <ProgresBarContent />
    </ProgressBarProvider>
  );
};

export default ProgressBar;
